import Vue from 'vue';
const resource = '/keygen';

export default {
  // CUSTOM ENDPOINT
  getOrganisation() {
    return Vue.prototype.$axiosMainClient.get(`${resource}/organisation`);
  },
};
